<!-- Start Page Title Area -->
<div class="page-title-area">
  <div class="container-fluid">
    <div class="page-title-content">
      <h2 data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">
        Contact Us
      </h2>
      <ul data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">
        <li><a routerLink="/">Home</a></li>
        <li>Contact Us</li>
      </ul>
    </div>
  </div>
</div>
<!-- End Page Title Area -->

<!-- Start Contact Area -->
<section class="contact-area ptb-110">
  <div class="container-fluid">
    <div class="section-title" style="max-width: 1300px !important">
      <!-- <h1>
                <b> Contact Us </b>
            </h1> -->
      <h2>Drop a Message for any Query</h2>
      <p style="max-width: 1300px !important">
        Please make sure to check our privacy policy before giving us
        your contact details. By filling out this form, you agree that
        you've read the policy and are okay with getting emails from us.
        <!-- You will have the option to unsubscribe at any time. -->
      </p>
    </div>

    <div class="row align-items-center">
      <!-- <div class="col-lg-4 col-md-4">
                <div
                    class="contact-image"
                     
                >
                    <img src="assets/img/contact-us.png" alt="image" />
                </div>
            </div> -->

      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="contact-form">
          <form [formGroup]="contactForm" method="post">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group mb-3">
                  <label class="formLabel">First Name:</label>
                  <input type="text" placeholder="Name" class="form-control" formControlName="firstName" [ngClass]="{
                                  'input-Error':
                                    contactForm.get('firstName').touched &&
                                    contactForm.get('firstName').dirty &&
                                    contactForm.get('firstName').invalid
                                }" />

                  <label class="formError" *ngIf="
                                contactForm.get('firstName').touched &&
                                contactForm.get('firstName').hasError('required') &&
                                contactForm.get('firstName').invalid
                              ">First Name is required!</label>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group mb-3">
                  <label class="formLabel">Last Name:</label>
                  <input type="text" placeholder="Surname" formControlName="lastName" class="form-control" [ngClass]="{
                                  'input-Error':
                                    contactForm.get('lastName').touched &&
                                    contactForm.get('lastName').dirty &&
                                    contactForm.get('lastName').invalid
                                }" />

                  <label class="formError" *ngIf="
                                  contactForm.get('lastName').touched &&
                                  contactForm.get('lastName').hasError('required') &&
                                  contactForm.get('lastName').invalid
                                ">Last Name is required!</label>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group mb-3">
                  <label class="formLabel">Subject:</label>
                  <input type="text" placeholder="Position" formControlName="position" class="form-control" [ngClass]="{
                                  'input-Error':
                                    contactForm.get('position').touched &&
                                    contactForm.get('position').dirty &&
                                    contactForm.get('position').invalid
                                }" />

                  <label class="formError" *ngIf="
                                contactForm.get('position').touched &&
                                contactForm.get('position').hasError('required') &&
                                contactForm.get('position').invalid
                              ">Subject is required!</label>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 form-group mb-3">
                <label class="formLabel">Email:</label>
                <input type="email" placeholder="name@example.com" formControlName="email" class="form-control"
                  [ngClass]="{
                                    'input-Error': contactForm.get('email').touched && contactForm.get('email').dirty && contactForm.get('email').invalid
                                  }" />
                <label class="formError" *ngIf="
                                  contactForm.get('email').touched &&
                                  contactForm.get('email').hasError('required') &&
                                  contactForm.get('email').invalid
                                ">
                  Email is required!
                </label>
                <!-- <label class="formError" *ngIf="
                                  contactForm.get('email').touched &&
                                  contactForm.get('email').hasError('email') &&
                                  contactForm.get('email').invalid
                                ">
                                  Invalid email format!
                                </label> -->
                <label class="formError" *ngIf="
                                  contactForm.get('email').touched &&
                                  contactForm.get('email').hasError('uppercaseEmail') &&
                                  contactForm.get('email').invalid
                                ">
                  Invalid email format!
                </label>
                <label class="formError" *ngIf="
                                  contactForm.get('email').touched &&
                                  contactForm.get('email').hasError('customEmailInvalid') &&
                                  contactForm.get('email').invalid
                                ">
                  Email domain is not allowed!
                </label>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group mb-3">
                  <label class="formLabel">Phone Number:</label>
                  <input type="text" placeholder="+91 XXXXXXXXXX" formControlName="contactNumber" class="form-control"
                    maxlength="10" (input)="onInputChange($event)" />
                  <label class="formError" *ngIf="
                                    contactForm.get('contactNumber').touched &&
                                    contactForm.get('contactNumber').hasError('required') &&
                                    contactForm.get('contactNumber').invalid
                                  ">
                    Phone Number is required!
                  </label>
                  <label class="formError" *ngIf="
                                    contactForm.get('contactNumber').touched &&
                                    contactForm.get('contactNumber').hasError('minlength') &&
                                    contactForm.get('contactNumber').invalid
                                  ">
                    Contact number must be 10 digits.
                  </label>
                  <label class="formError" *ngIf="
                                    contactForm.get('contactNumber').touched &&
                                    contactForm.get('contactNumber').hasError('maxlength') &&
                                    contactForm.get('contactNumber').invalid
                                  ">
                    Contact number must be 10 digits.
                  </label>
                  <label class="formError" *ngIf="
                                    contactForm.get('contactNumber').touched &&
                                    contactForm.get('contactNumber').hasError('pattern') &&
                                    contactForm.get('contactNumber').invalid
                                  ">
                    Contact number must contain only digits.
                  </label>
                </div>
              </div>


              <div class="col-lg-4 col-md-4 col-sm-12 form-group mb-3">
                <label class="formLabel">Location:</label>
                <input type="text" placeholder="Location" formControlName="location" class="form-control" [ngClass]="{
                                'input-Error':
                                  contactForm.get('location').touched &&
                                  contactForm.get('location').dirty &&
                                  contactForm.get('location').invalid
                              }" />
                <label class="formError" *ngIf="
                                contactForm.get('location').touched &&
                                contactForm.get('location').hasError('required') &&
                                contactForm.get('location').invalid
                              ">Location is required!</label>
              </div>
            </div>


            <div class="row">


              <div class="col-lg-12 col-md-12 col-sm-12 form-group mb-3">
                <label class="formLabel">Additional information:</label>
                <textarea placeholder="What are you interested in?" formControlName="detail" class="form-control"
                  cols="30" rows="5" [ngClass]="{
                                  'input-Error':
                                    contactForm.get('detail').touched &&
                                    contactForm.get('detail').dirty &&
                                    contactForm.get('detail').invalid
                                }"></textarea>
                <label class="formError" *ngIf="
                                  contactForm.get('detail').touched &&
                                  contactForm.get('detail').dirty &&
                                  contactForm.get('detail').invalid
                                ">Description is required!</label>
              </div>
            </div>
            <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                            <div class="check">
                                <input type="checkbox" class="checkbox-custom" formControlName="checkbox" [ngClass]="{
                                'input-Error':
                                  contactForm.get('checkbox').touched &&
                                  contactForm.get('checkbox').dirty &&
                                  contactForm.get('checkbox').invalid
                              }">
                                <span class="checkbox-label" style="padding-left: 10px;">By filling out this form, you
                                    agree
                                    that you’ve read the policy and are receiving emails from us.</span>


                            </div>

                            


                        </div> -->
            <div class="col-lg-12 col-md-12 col-sm-12 mt-5 form-Group">
              <re-captcha 
              #captchaRef="reCaptcha" 
              (resolved)="resolved($event)" 
              (error)="onError($event)"
              (expired)="onCaptchaExpired()" 
              [siteKey]="siteKey" 
              errorMode="handled">
            </re-captcha>
            </div>


            <div class="row" style="padding-top: 25px;">

              <div class="col-lg-12 col-md-12 col-sm-12">
                <button type="submit" class="btns btn-primarys" (click)="sendMail()">
                  Send Message
                </button>
                <div id="msgSubmit" class="h3 text-center hidden"></div>
                <div class="clearfix"></div>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="contact-info-box">
          <div class="icon">
            <i class="bx bx-envelope"></i>
          </div>

          <h3>Email Us</h3>
          <p><a href="mailto:info@vocbot.ai">info@vocbot.ai</a></p>
        </div>
      </div>

      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="contact-info-box">
          <div class="icon">
            <i class="bx bx-phone-call"></i>
          </div>

          <h3>Call Us</h3>
          <p><a href="tel:9826323332">+91-9826323332</a></p>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="contact-info-box">
          <div class="icon">
            <i class="fa fa-map-marker"></i>
          </div>

          <h3>Address</h3>
          <p style="margin-bottom: 0px !important">
            <a>43, Pratap Nagar, Near Manik Bagh
              Road, Indore (M.P.) 452007</a>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="contact-info-box" style="text-align: center">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3680.6459084147004!2d75.85206112603005!3d22.704221828132127!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962fdaa1e040df1%3A0x2d4c8f1b5a736577!2sPratap%20Nagar%2C%20Roop%20Ram%20Nagar%2C%20Indore%2C%20Madhya%20Pradesh%20452007!5e0!3m2!1sen!2sin!4v1709527919027!5m2!1sen!2sin"
          width="100% !important" height="430" style="border:0;" allowfullscreen="" loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
  </div>
</section>
<!-- End Contact Area -->